<div fxLayout="column">
    <form [formGroup]="pickerForm">
        <list-select-ctrl [caption]="'claims-center.claimMessages.templateType'" [settings]="{fxFill:true}"
        [formControlName]="'selectedTemplate'" [textField]="'templateName'" [valueField]="'id'" [primitiveValue]="false"
        [valuesList$]="templates$" (valueChangeEvent)="templateSelected()"></list-select-ctrl>
    </form>
    <div *ngIf="!!selectedTemplate" fxLayout="column">
        <div>
            <strong>{{'claims-center.claimMessages.title' | translate}} :</strong> {{selectedTemplate.title}}
        </div>
        <div>
            <strong>{{'claims-center.claimMessages.contentTemplate' | translate}} :</strong>
            <div [innerHtml]="selectedTemplate.templateContent | safe:'html'"></div>
        </div>
       
    </div>
</div>

<kendo-dialog-actions>
    <button kendoButton (click)="confirm()" [primary]="true" submit>
        <span>{{'global.confirm' | translate}}</span>
    </button>
</kendo-dialog-actions> 
